<template>
  <div class="piece-rate-salary">
    <AppBar />
    <div class="page-content">
      <div class="piece-rate-salary-canvas">
        <div class="piece-rate-salary-background">
          <img :src="top.imgBack" alt="" />
        </div>
        <div class="por-container">
          <div class="solution-info">
            <div class="solution-info-title">{{ top.title }}</div>
            <div class="solution-info-content" v-html="top.content">
              <!-- 利用在线招聘流程，帮助企业实现智能、便捷的招聘模式，
              建立企业自己的人才储备机制 -->
            </div>
            <!-- <div class="solution-btn">预约演示</div> -->
          </div>
        </div>
      </div>
      <div ref="nav" class="piece-rate-salary-nav">
        <div ref="navTabs" class="piece-rate-salary-tabs" :style="{width: navWidth+'%', height: navHeight+'px'}">
          <div
            v-for="(item, index) in navList"
            :key="index"
            :class="['piece-rate-salary-nav-item', topNaviId === item.id ? 'top-nav-item' : '']"
            @click="goAnchor(item)"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
      <div>
        <div ref="pain-points" class="pain-points">
          <div class="title">企业件薪计算的痛点</div>
          <div class="pain-points-list">
            <div
              v-for="(item, index) in painPointsList"
              :key="index"
              class="pain-points-list-item"
              :class="{ 'change-pain-points': painPointsIndex === index }"
              @mousemove="onmousemove(index)"
            >
              <div class="item-text-box">
                <div class="item-title">{{ index+1 }}.{{ item.title }}</div>
                <div v-show="painPointsIndex === index " class="item-describe">{{ item.describe }}</div>
              </div>
              <div class="pain-points-list-index">0{{ index+1 }}</div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div ref="sense-of-worth" class="sense-of-worth">
          <div class="title">产品价值体现</div>
          <div class="sense-of-worth-list">
            <div
              v-for="(item, index) in senseOfWorthList"
              :key="index"
              :style="{'backgroundColor': item.contentColor}"
              class="sense-worth-list-item"
            >
              <img :src="item.contentImg" alt="" class="content-img" />
            </div>
          </div>
        </div>
      </div>
      <div>
        <div ref="solution" class="solution">
          <div class="title">计件薪酬业务解决方案</div>
          <div class="solution-list">
            <div
              v-for="(item, index) in solutionList"
              :key="index"
              class="solution-list-item"
            >
              <div class="solution-item-content">
                <div class="content-text">
                  <div class="content-title">{{ item.title }}</div>
                  <div
                    v-for="(textItem, textIndex) in item.describeList"
                    :key="textIndex"
                    class="content-text-index"
                  >
                    <img :src="require('@/assets/staffmanage/icon/liIcon.png')" alt="" />
                    <div class="text">{{ textItem }}</div>
                  </div>
                </div>
                <div class="content-img">
                  <img :src="item.img" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <RightFixedgt />
    <FootWrap />
    <AltProduct ref="altProduct" />
    <ast ref="ast" />
  </div>
</template>

<script>
import { getColumnChild, getColumnDetail } from '@/api/column';
import { getContentList, getContentDetail } from '@/api/content';

export default {
  name: 'PieceRateSalary',
  data () {
    return {
      top: {
        title: '',
        content: '',
        imgBack: require('@/assets/piecerate/canvas.gif'),
      },
      navWidth: 80,
      navHeight: 60,
      offsetTop: 0,
      scrollTop: 0,
      position: 0,
      topNaviId: null,
      navList: [
        {
          title: '企业痛点',
          id: 'pain-points',
        },
        {
          title: '产品价值观',
          id: 'sense-of-worth',
        },
        {
          title: '解决方案',
          id: 'solution',
        },
      ],
      painPointsList: [
        // {
        //   title: '手工统计为主，误差率高',
        //   describe: '大多数产量信息是统计员通过手工登记，管理人员无法有效核验数据。',
        // },
        // {
        //   title: '为应对产量要求，出现虚报情况',
        //   describe: '大多数产量信息是统计员通过手工登记，管理人员无法有效核验数据。',
        // },
        // {
        //   title: '临时性调动频繁，成本归属难分清',
        //   describe: '大多数产量信息是统计员通过手工登记，管理人员无法有效核验数据。',
        // },
        // {
        //   title: '集体计件分配规则复杂，Excel核算耗时耗力',
        //   describe: '大多数产量信息是统计员通过手工登记，管理人员无法有效核验数据。',
        // },
      ],
      painPointsIndex: 0,
      senseOfWorthList: [
        // {
        //   contentImg: require('@/assets/piecerate/senseofworth1.png'),
        //   contentColor: '#f5f4fe',
        // },
        // {
        //   contentImg: require('@/assets/piecerate/senseofworth2.png'),
        //   contentColor: '#f0f4ff',
        // },
        // {
        //   contentImg: require('@/assets/piecerate/senseofworth3.png'),
        //   contentColor: '#e2f1fb',
        // },
        // {
        //   contentImg: require('@/assets/piecerate/senseofworth4.png'),
        //   contentColor: '#dcf8f4',
        // },
      ],
      solutionList: [
        // {
        //   title: '建立一体化的数据流程管理',
        //   img: require('@/assets/piecerate/solution1.png'),
        //   describeList: [
        //     '共享HR人员基础资料，快速实现与生产管理系统互通',
        //     'API标准接口无缝对接第三方系统，  减少手工环节带来的数据错误',
        //     '报工数据与入仓数据相互验证，保证数据准确性',
        //   ],
        // },
        // {
        //   title: '多版块联动，智能识别成本归属',
        //   img: require('@/assets/piecerate/solution2.png'),
        //   describeList: [
        //     '与考勤数据联动，快速识别人员出勤状态',
        //     '智能完成工时统计与核算',
        //     '与财务成本架构关联，自动产生人工成本分析',
        //     '与人员异动版块关联，“异动”前后数据自动分离',
        //   ],
        // },
        // {
        //   title: '减少手工操作节点，明确权责，减少推诿',
        //   img: require('@/assets/piecerate/solution3.png'),
        //   describeList: [
        //     '通过系统工具使得“计划”、“派工”走全线上管理模式',
        //     '各个单据实现电子审批，各个节点权责明确',
        //     '计件工资每日自动推送员工确认，提升员工信任感',
        //   ],
        // },
      ],
    };
  },
  watch: {
    scrollTop(newValue, oldValue) {
      setTimeout(() => {
        if (newValue === window.scrollY) {
          for (var i = 0; i < this.navList.length; i++) {
            var elementTop = this.$refs[`${this.navList[i].id}`].offsetTop - this.scrollTop - 1;
            if (elementTop <= 70) {
              this.topNaviId = this.navList[i].id;
            }
          }
        }
      }, 20);
    },
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll);
    this.$nextTick(() => {
      const nav = this.$refs.nav;
      this.offsetTop = nav.offsetTop;
    });
    this.getPageColumn();
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      var offsetHeight = this.$refs.navTabs.offsetHeight;
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      var headerFixed = this.scrollTop > this.offsetTop - offsetHeight / 2 - 70;
      var scroll = this.scrollTop - this.position;
      this.position = this.scrollTop;
      if (this.scrollTop <= 400) {
        this.navHeight = 52;
        this.navWidth = 80;
        this.$refs.nav.style.position = 'relative';
        this.$refs.nav.style.top = '0px';
        this.topNaviId = null;
      } else if (this.scrollTop >= 400 && !headerFixed) {
        this.navHeight += 0.04 * scroll;
        this.navWidth += 0.12 * scroll;
        this.$refs.navTabs.style.top = -(offsetHeight / 2) + 'px';
        this.$refs.nav.style.position = 'relative';
        this.$refs.nav.style.top = '0px';
        this.topNaviId = null;
      } else if (headerFixed) {
        this.navHeight = 60;
        this.navWidth = 100;
        this.$refs.navTabs.style.top = -(offsetHeight / 2) + 'px';
        this.$refs.nav.style.position = 'fixed';
        this.$refs.nav.style.top = offsetHeight / 2 + 70 + 'px';
      }
    },
    goAnchor(i) {
      // var id = '#' + i.id;
      // document.querySelector(id).scrollIntoView({
      //   behavior: 'smooth',
      //   block: 'start',
      // });
      window.scrollTo({
        top: this.$refs[`${i.id}`].offsetTop - 70,
        left: 0,
        behavior: 'smooth',
      });
    },

    // 获取页面栏目
    async getPageColumn() {
      const params = { parentId: '1607260226636177408', };
      getColumnChild(params).then(async (res) => {
        const { result, } = res;
        for (var i = 0; i < result.length; i++) {
          if (result[i].name === '企业痛点') {
            const data = { columnId: result[i].id, pageNum: 1, pageSize: 99, };
            getContentList(data).then(async (rrs) => {
              const rrsult = rrs.result;
              for (var j = 0; j < rrsult.data.length; j++) {
                const rts = await getContentDetail(rrsult.data[j].id);
                const rtsult = rts.result;
                var painPointsItem = {
                  title: rtsult.title,
                  describe: rtsult.description,
                };
                this.painPointsList.push(painPointsItem);
              }
            });
          } else if (result[i].name === '产品价值观') {
            const data = { columnId: result[i].id, pageNum: 1, pageSize: 99, };
            this.valueCenterImg = result[i].icon;
            getContentList(data).then(async (rrs) => {
              const rrsult = rrs.result;
              for (var j = 0; j < rrsult.data.length; j++) {
                var valueAnalysisItem = {
                  contentImg: rrsult.data[j].icon,
                  contentColor: '#' + rrsult.data[j].summaryTitle,
                };
                this.senseOfWorthList.push(valueAnalysisItem);
              }
            });
          } else if (result[i].name === '解决方案') {
            const data = { columnId: result[i].id, pageNum: 1, pageSize: 99, };
            getContentList(data).then(async (rrs) => {
              const rrsult = rrs.result;
              for (var j = 0; j < rrsult.data.length; j++) {
                var solutionItem = {
                  title: rrsult.data[j].title,
                  img: rrsult.data[j].icon,
                  describeList: [],
                };
                const rts = await getContentDetail(rrsult.data[j].id);
                const rtsult = rts.result;
                for (var x = 0; x < rtsult.elements.length; x++) {
                  solutionItem.describeList.push(rtsult.elements[x].content);
                }
                this.solutionList.push(solutionItem);
              }
            });
          } else if (result[i].name === '顶部图') {
            getColumnDetail(result[i].id).then((rrs) => {
              const rrsult = rrs.result;
              var content = rrsult.elements.find(obj => obj.name === 'content').content;
              var contentdoc = new DOMParser().parseFromString(content, 'text/html');
              this.top.title = rrsult.elements.find(obj => obj.name === 'subtitle').content;
              this.top.content = contentdoc.documentElement.textContent.replace(/&nbsp;/g, ' ');
              // this.top = {
              //   imgBack: rrsult.icon,
              // };
            });
          }
        }
      });
    },

    onmousemove(i) {
      this.painPointsIndex = i;
    },
    openBealter () {
      this.$refs.altProduct.tobealter();
    },
    openBealter2() {
       this.$refs.ast.drawer  = true
    },
  },
};
</script>

<style lang="less" scoped>
.piece-rate-salary{
  background-color: #fff;
  .page-content{
    width: 100%;
    .piece-rate-salary-canvas{
      width: 100%;
      height: fit-content;
      min-width: var(--minwidth);
      position: relative;
      background-size: cover;
      overflow: hidden;
      .piece-rate-salary-background{
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background-position: top;
        background-size: cover;
        background-repeat: no-repeat;
        img{
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center top;
        }
      }
      .por-container {
        width: 70%;
        max-width: 1200px;
        margin: 0 auto;
        position: relative;
        .solution-info {
          width: 480px;
          height: 560px;
          display: flex;
          justify-content: center;
          flex-direction: column;
          box-sizing: border-box;
          .solution-info-title {
            font-size: 46px;
            font-weight: bold;
            line-height: 55px;
            color: #fff;
            margin-bottom: 29px;
          }
          .solution-info-content {
            font-size: 20px;
            line-height: 32px;
            color: #fff;
            margin-bottom: 44px;
          }
          // .solution-btn {
          //   width: 142px;
          //   height: 48px;
          //   background-color: #1589fd;
          //   color: #fff;
          //   text-align: center;
          //   line-height: 48px;
          //   cursor: pointer;
          //   border-radius: 24px;
          // }
        }
      }
    }
    .piece-rate-salary-nav{
      width: 100%;
      display: flex;
      position: relative;
      justify-content: center;
      z-index: 50;
      .piece-rate-salary-tabs{
        margin: 0 auto;
        box-shadow: 0px 2px 8px 0px rgba(139, 139, 139, 0.18);
        border-radius: 2px;
        background-color: #fff;
        display: flex;
        position: absolute;
        top: -26px;
        .piece-rate-salary-nav-item{
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #181818;
          font-size: 14px;
          cursor: pointer;
        }
        .piece-rate-salary-nav-item:hover{
          color: #00b0dc;
        }
        .top-nav-item {
          color: #fff;
          background-color: #00b0dc;
        }
        .top-nav-item:hover {
          color: #fff;
        }
      }
    }
    .pain-points{
      width: 1200px;
      padding-top: 115px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .title{
        font-size: 32px;
        color: #181818;
        line-height: 1;
        margin-bottom: 70px;
      }
      .pain-points-list{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .pain-points-list-item{
          flex: 1;
          min-width: 228px;
          height: 210px;
          margin-left: 15px;
          padding: 25px 18px 30px 30px;
          position: relative;
          box-sizing: border-box;
          background-color: #fff;
          border-left: 5px solid #00b0dc;
          box-shadow: 0px 5px 24px 0px rgba(200, 200, 200, 0.2);
          transition: all 0.3s ease-in-out;
          .item-text-box{
            width: 160px;
            position: relative;
            z-index: 9;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            margin-top: 20px;
            // transition: all 0.3s ease-in-out;
            overflow: hidden;
            .item-title{
              font-size: 18px;
              font-weight: 500;
              color: #1e2127;
              transition: all 0.3s ease-in-out;
            }
            .item-describe{
              width: 224px;
              margin-top: 17px;
              font-size: 16px;
              font-weight: 300;
              color: #cedeff;
              transition: all 0.3s ease-in-out;
            }
          }
          .pain-points-list-index{
            z-index: 0;
            position: absolute;
            line-height: 1;
            top: 15px;
            right: 0;
            font-size: 150px;
            font-family: Roboto-Bold;
            color: #f4f6fe;
            transition: all 0.3s ease-in-out;
          }
        }
        .pain-points-list-item:first-child{
          margin-left: 0;
        }
        .change-pain-points{
          flex: 2.5;
          background-color: #00b0dc;
          .item-text-box{
            width: 224px;
            .item-title{
              color: #fff;
            }
          }
          .pain-points-list-index{
            color: #15b9e2;
          }
        }
      }
    }
    .sense-of-worth{
      width: 1200px;
      padding-top: 120px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .title{
        font-size: 32px;
        color: #181818;
        line-height: 1;
        margin-bottom: 70px;
      }
      .sense-of-worth-list{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .sense-worth-list-item{
          width: 288px;
          height: 331px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 24px;
          transform: translateY(0);
          overflow: hidden;
          .content-img{
            border-radius: 16px;
            box-shadow: 0px 5px 24px 0px rgba(200, 200, 200, 0.35);
          }
        }
        .sense-worth-list-item:hover{
          transform: translateY(-10px);
        }
      }
    }
    .solution{
      width: 100%;
      padding-top: 120px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .title{
        font-size: 32px;
        color: #181818;
        line-height: 1;
        margin-bottom: 70px;
      }
      .solution-list{
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        .solution-list-item{
          width: 100%;
          height: 514px;
          background-color: #ffffff;
          .solution-item-content{
            width: 1200px;
            margin: 30px auto;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            .content-text{
              width: 410px;
              padding-top: 60px;
              margin-right: 60px;
              box-sizing: border-box;
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              justify-content: flex-start;
              .content-title{
                width: 100%;
                font-size: 28px;
                font-family: OPPOSans-M;
                color: #181818;
                line-height: 40px  ;
                font-weight: 600;
                margin-bottom: 36px;
              }
              .content-text-index{
                width: 100%;
                display: flex;
                justify-content: flex-start;
                align-items: flex-start;
                margin-bottom: 30px;
                img{
                  display: block;
                  width: auto;
                  height: 16px;
                  margin-top: 2px;
                  margin-right: 6px;
                }
                .text{
                  font-size: 16px;
                  color: #181818;
                  line-height: 26px;
                }
              }
            }
            .content-img{
              flex: 1;
              img{
                display: block;
                width: 100%;
                height: auto;
              }
            }
          }
        }
        .solution-list-item:nth-child(2n){
          background-color: #f3f5fa;
          .solution-item-content{
            flex-direction: row-reverse;
            .content-text{
              margin-left: 60px;
              margin-right: 0;
              box-sizing: border-box;
            }
          }
        }
      }
    }
  }
}
</style>
